import { takeEvery, put, call, takeLatest } from "redux-saga/effects";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

import {
  FETCH_SKILLS_REQUEST,
  FETCH_SKILLS_SUCCESS,
  FETCH_SKILLS_FAILURE,
  SAVE_SKILL_REQUEST,
  SAVE_SKILL_SUCCESS,
  SAVE_SKILL_FAILURE,
  DELETE_SKILL_REQUEST,
  DELETE_SKILL_SUCCESS,
  DELETE_SKILL_FAILURE,
  SAVE_EMPLOYEE_SKILLS_REQUEST,
  GET_EMPLOYEE_SKILLS_REQUEST,
  GET_EMPLOYEE_SKILLS_SUCCESS,
  GET_EMPLOYEE_SKILLS_FAILURE,
  SAVE_EMPLOYEE_SKILLS_SUCCESS,
  SAVE_EMPLOYEE_SKILLS_FAILURE,
} from "./actionTypes";

/* Fetch Skill Master */
function* fetchSkillsSaga(action) {
  try {
     const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(
      post,
      process.env.REACT_APP_GET_SKILLS_LIST,
      formData
    );

    yield put({ type: FETCH_SKILLS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Fetch Skills Error:", error);
    yield put({
      type: FETCH_SKILLS_FAILURE,
      payload: error.message,
    });
  }
}

/* Save Skill (Create / Update) */
function* saveSkillSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_SKILL,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save skill!");
    }

    yield put({ type: SAVE_SKILL_SUCCESS, payload: response });
    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Skill Error:", error);
    yield put({ type: SAVE_SKILL_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

/* Delete Skill */
function* deleteSkillSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DELETE_SKILL,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to delete skill!");
    }

    yield put({ type: DELETE_SKILL_SUCCESS, payload: response });
    Swal.fire("Deleted!", response.message, "success");
  } catch (error) {
    yield put({ type: DELETE_SKILL_FAILURE, payload: error.message });
    Swal.fire("Error", error.message, "error");
  }
}

function* getEmployeeSkillsSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_GET_EMPLOYEE_SKILLS,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch employee skills!");
    }

    yield put({
      type: GET_EMPLOYEE_SKILLS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Get Employee Skills Error:", error);
    yield put({
      type: GET_EMPLOYEE_SKILLS_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}

function* saveEmployeeSkillsSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_EMPLOYEE_SKILLS,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save employee skills!");
    }

    yield put({
      type: SAVE_EMPLOYEE_SKILLS_SUCCESS,
      payload: response,
    });

    Swal.fire("Success", response.message, "success");
  } catch (error) {
    console.error("Save Employee Skills Error:", error);
    yield put({
      type: SAVE_EMPLOYEE_SKILLS_FAILURE,
      payload: error.message,
    });
    Swal.fire("Error", error.message, "error");
  }
}


/* Watcher */
export default function* skillMasterSaga() {
  yield takeLatest(FETCH_SKILLS_REQUEST, fetchSkillsSaga);
  yield takeLatest(SAVE_SKILL_REQUEST, saveSkillSaga);
  yield takeLatest(DELETE_SKILL_REQUEST, deleteSkillSaga);
  yield takeLatest(GET_EMPLOYEE_SKILLS_REQUEST, getEmployeeSkillsSaga);
  yield takeLatest(SAVE_EMPLOYEE_SKILLS_REQUEST, saveEmployeeSkillsSaga);
}